import React from "react";
import { X, Star } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";

export default function FavouritesSheet({
  open,
  onOpenChange,
  favourites,
  onRemove,
  onClear,
  onOpenSingle,
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="border-white/10 bg-[#0e0e10] text-white">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 text-white">
            <Star className="h-4 w-4 text-amber-400" fill="currentColor" />
            Saved domains
          </SheetTitle>
        </SheetHeader>

        {favourites.length === 0 ? (
          <p className="mt-6 text-sm text-zinc-500">
            No saved domains yet. Tap the star on any result to save it here.
          </p>
        ) : (
          <div className="mt-6 space-y-2">
            {favourites.map((d) => (
              <div
                key={d}
                className="flex items-center gap-3 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-2"
              >
                <button
                  onClick={() => {
                    onOpenSingle(d.split(".")[0]);
                    onOpenChange(false);
                  }}
                  className="flex-1 truncate text-left font-mono text-sm text-zinc-200 transition-colors hover:text-white"
                >
                  {d}
                </button>
                <button
                  onClick={() => onRemove(d)}
                  className="shrink-0 text-zinc-500 transition-colors hover:text-red-400"
                  aria-label={`Remove ${d}`}
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            ))}
            <button
              onClick={onClear}
              className="mt-2 text-xs text-zinc-500 transition-colors hover:text-white"
            >
              Clear all
            </button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
